export const attributesSelector = state => state.contactImport.attributes;
export const dataSelector = state => state.contactImport.data;
export const filenameSelector = state => state.contactImport.filename;
export const groupSelector = state => state.contactImport.group;
export const idSelector = state => state.contactImport && state.contactImport.id ? state.contactImport.id : null;
export const mapSelector = state => state.contactImport.map;
export const duplicateActionSelector = state => state.contactImport.duplicateAction;